import { render, staticRenderFns } from "./ResultTitle.vue?vue&type=template&id=42bb47f1"
import script from "./ResultTitle.vue?vue&type=script&lang=js"
export * from "./ResultTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports